import React from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ScienceIcon from '@mui/icons-material/Science';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const FEATURES = [
  {
    icon: <HealthAndSafetyIcon fontSize="small" />,
    label: 'HIPAA-safe synthetic patient data — no real PHI ever touches your pipeline',
  },
  {
    icon: <ScienceIcon fontSize="small" />,
    label: 'CDISC SDTM clinical trial subjects with realistic MedDRA adverse events',
  },
  {
    icon: <FileDownloadIcon fontSize="small" />,
    label: 'Export to CSV, JSON, FHIR, or your data warehouse in one click',
  },
];

export default function OnboardingScreen() {
  const email = useSelector((s) => s.user?.email || s.user?.profile?.email || '');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 420,
        px: 4,
        py: 6,
        textAlign: 'center',
      }}
    >
      <AutoAwesomeIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />

      <Typography variant="h5" fontWeight={700} gutterBottom>
        {email ? `Welcome, ${email.split('@')[0]}` : 'Welcome to Cynthia'}
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 1, maxWidth: 480 }}>
        Your workspace is being provisioned. This usually takes just a few minutes — you'll
        have access shortly.
      </Typography>

      <Chip
        label="Workspace provisioning in progress"
        color="primary"
        variant="outlined"
        size="small"
        sx={{ mb: 4 }}
      />

      <Stack spacing={2} sx={{ maxWidth: 440, textAlign: 'left' }}>
        {FEATURES.map(({ icon, label }, i) => (
          <Stack key={i} direction="row" spacing={1.5} alignItems="flex-start">
            <Box sx={{ color: 'primary.main', mt: 0.25, flexShrink: 0 }}>{icon}</Box>
            <Typography variant="body2" color="text.secondary">
              {label}
            </Typography>
          </Stack>
        ))}
      </Stack>

      <Typography variant="caption" color="text.disabled" sx={{ mt: 5 }}>
        Refresh the page in a few minutes to check if your workspace is ready.
        {' '}If it's taking longer than expected, reach out to{' '}
        <a href="mailto:support@bacclabs.io" style={{ color: 'inherit' }}>
          support@bacclabs.io
        </a>
      </Typography>
    </Box>
  );
}
